import { Controller } from '@hotwired/stimulus'
import PhotoSwipeLightbox from 'photoswipe/lightbox'

export default class extends Controller {
  initialize() {
    this.lightbox = new PhotoSwipeLightbox({
      gallery: '#gallery',
      children: 'a',
      pswpModule: () => import('photoswipe')
    })
    this.lightbox.init()
  }

  disconnect() {
    this.lightbox.destroy()
  }
}
